module.exports = __webpack_public_path__ + "img/white-arrow.16f26e1b.png";